import { schema } from "normalizr";

const kraftstoffSchema = new schema.Entity(
  "kraftstoff",
  {},
  { idAttribute: "id" }
);

export { kraftstoffSchema };
